import React from "react";
import { NavLink } from "react-router-dom"
import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import { withAuth } from "../../withAuth";
import { withRouter } from "react-router-dom";
import { guestLang } from "./guestLang";

class GuestStatisticPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hideNav: '',            
            usersAgent: this.props.UsersAgent,
            Language: localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        }
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    resize() {
        this.setState({ hideNav: window.innerWidth <= 1100 });
    }

    formatedDate(date) {
        let tempDate = date + '';
        if (tempDate.length<2){
            tempDate = '0' + tempDate;
        }
        return tempDate;
    }

    render() {

        let agentTable = [];
        //console.log(this.state.usersAgent);
        this.state.usersAgent.forEach(user => {
            
            let DateReg = new Date(user.DateRegistration);
            
            if (user.Balance == 0) {                
                agentTable.push({
                    Name: user.Name,
                    Surname: user.Surname,
                    email: user.email,
                    StatusMain: user.StatusMain,
                    DateRegistration: `${this.formatedDate(DateReg.getDate())}-${this.formatedDate(DateReg.getMonth() + 1)}-${this.formatedDate(DateReg.getFullYear())} ${this.formatedDate(DateReg.getHours())}:${this.formatedDate(DateReg.getMinutes())}:${this.formatedDate(DateReg.getSeconds())}`
                });
            }           

        });

        const agentTableRef = agentTable.map(function (item, i) {            
            return (
                <tr>                    
                    <td>{item.email}</td>
                    <td>{item.Name}</td> 
                    <td>{item.Surname}</td>                                       
                    <td>Guest</td>
                    <td>{item.DateRegistration}</td>
                </tr>
            )
        });

        return (
            <div className="ReferalStatisticPage ">
                <TopPafeInfo session={this.props.session} />

                <div className="ReferalPageTop ">                    
                    <div className="ReferalPageTopLink"><NavLink to='/referalstatistic' activeClassName="ReferalPageTopActiveLink">{guestLang.statistic[this.state.Language]}</NavLink></div>
                    <div className="ReferalPageTopLink activeTab"><NavLink to='/myguest' activeClassName="ReferalPageTopActiveLink">{guestLang.guest[this.state.Language]}</NavLink></div>
                </div>
                <div className="ReferalPageMain">                   
                    <div className="ReferalStatisticPageMainIn ReferalStatisticPageMainComp">
                        <div className="ReferalStatisticPageTable">
                            <div className="ReferalStatisticPageTitle">{guestLang.title[this.state.Language]}</div>
                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <th>E-MAIL</th>
                                    <th>{guestLang.name[this.state.Language]}</th>
                                    <th>{guestLang.surname[this.state.Language]}</th>                                                                        
                                    <th>{guestLang.status[this.state.Language]}</th>
                                    <th>{guestLang.date[this.state.Language]}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {agentTableRef}
                            </tbody>
                        </table>

                    </div>                    
                </div>
            </div>
        )
    }
}

export default withAuth(session => session && session)(withRouter(GuestStatisticPage));